<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="年度：" prop="year">
                <span>{{model.year}}</span>
            </el-form-item>
            <!-- <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item> -->
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="CARID：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="年报图URL：" prop="poster_url">
                <span>{{model.poster_url}}</span>
            </el-form-item>
            <el-form-item label="生成用时：" prop="use_time">
                <span>{{model.use_time}}（秒）</span>
            </el-form-item>
            <el-form-item label="生成时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carYearInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                year: '',
                member_id: '',
                email: '',
                car_id: '',
                poster_url: '',
                use_time: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/caryear/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>